let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5IgYU"), load("1FTmX")]).then(() => parcelRequire('aGHdx'));